/**
 * Helper utility functions
 */

/**
 * Get validation messages from API response
 * @param data API response data
 * @returns Formatted validation message string
 */
export const getValidationMessages = (data: any): string => {
  if (!data) return '';

  // Handle different error response formats
  if (typeof data === 'string') {
    return data;
  }

  if (Array.isArray(data)) {
    return data
      .map((item, idx) => `${idx + 1}. ${getValidationMessages(item)}`)
      .join('\n ');
  }

  // Nếu data là object dạng { field: "error message", ... }
  if (typeof data === 'object' && data !== null) {
    // Lấy tất cả value, bỏ qua key
    // Nếu value là mảng (như Django REST), nối lại
    return Object.values(data)
      .map(v => (Array.isArray(v) ? v.join('\n ') : String(v)))
      .join(' \n ');
  }

  return '';
};

/**
 * Format currency for Vietnamese locale
 * @param value Amount to format
 * @returns Formatted currency string
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(value);
};

/**
 * Format number for Vietnamese locale
 * @param value Number to format
 * @returns Formatted number string
 */
export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('vi-VN').format(value);
};

/**
 * Format date for Vietnamese locale
 * @param date Date to format
 * @returns Formatted date string
 */
export const formatDate = (date: string | Date): string => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Format datetime for Vietnamese locale
 * @param date Date to format
 * @returns Formatted datetime string
 */
export const formatDateTime = (date: string | Date): string => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export default {
  getValidationMessages,
  formatCurrency,
  formatNumber,
  formatDate,
  formatDateTime,
};
